export enum I18nLang {
  ET = 'et',
  FI = 'fi',
  SV = 'sv',
}
